<div class="section">
    <div data-qa-id="locums-rec-additional-details-header" class="nova__label">Additional Details:</div>
    <div data-qa-id="locums-rec-additional-details-value" [innerHtml]="description | linkify:'_blank'"></div>
    <ng-container
        *ngIf="(!displayConfigData?.hideDetails && (displayConfigData?.details !== '' && displayConfigData?.details !== null))">
        <div data-qa-id="locums-rec-additional-details-external-view-header" class="external-info_title external-info">
            <span class="material-icons">info</span>Details:
        </div>
        <div data-qa-id="locums-rec-additional-details-external-view-value">
            <span class="external-info">
                Displays as "<span [innerHTML]="displayConfigData?.details"></span>"
            </span>
        </div>
    </ng-container>
</div>